import React from 'react';
import { Td, Text, Tr, useBreakpointValue } from '@chakra-ui/react';
import ExpandableText from 'ts/common/components/ExpandableText';

interface Props {
    description: Nullable<string>;
    itemPrice: string;
    name: string;
    quantity: number | string;
    totalPrice: string;
}

const ClientInvoiceItemTableRow: React.FC<Props> = ({
    description,
    itemPrice,
    name,
    quantity,
    totalPrice
}) => {
    const isLargeScreen = useBreakpointValue({ base: false, lg: true });

    return (
        <React.Fragment>
            <Tr>
                <Td borderBottom="none" borderTopStyle="solid" borderTopWidth="1px">
                    <Text fontWeight="semibold" fontSize="16px">
                        {name}
                    </Text>
                </Td>
                <Td
                    borderBottom="none"
                    borderTopStyle="solid"
                    borderTopWidth="1px"
                    textAlign="center"
                >
                    {quantity}
                </Td>
                {isLargeScreen && (
                    <Td
                        borderBottom="none"
                        borderTopStyle="solid"
                        borderTopWidth="1px"
                        textAlign="right"
                    >
                        {itemPrice}
                    </Td>
                )}
                <Td
                    borderBottom="none"
                    borderTopStyle="solid"
                    borderTopWidth="1px"
                    textAlign="right"
                >
                    {totalPrice}
                </Td>
            </Tr>
            {description && (
                <Tr>
                    <Td colSpan={isLargeScreen ? 1 : 3} borderBottom="none" paddingTop="0">
                        <ExpandableText
                            fontSize="14px"
                            fontWeight="light"
                            whiteSpace="pre-line"
                            maxLines={3}
                        >
                            {description}
                        </ExpandableText>
                    </Td>
                </Tr>
            )}
        </React.Fragment>
    );
};

export default ClientInvoiceItemTableRow;
